import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCurrentGroup = (group) => ({
  type: actionTypes.SET_CURRENT_GROUP,
  payload: group
})
